import { useContext, useEffect, useState, useRef } from 'react';

import { activityOverseaCouponTips, isCounponUnavailableForOversea, selectProductLabel } from '@lcsc-ui/apis/activity';
import { selectProductFavorite } from '@lcsc-ui/apis/member';
import { searchMoreChannel, searchAlias } from '@lcsc-ui/apis/overseas';
import EmptyText from '@lcsc-ui/components/EmptyText';
import ProductItem from '@lcsc-ui/components/ProductItem/productItem';
import ProductList from '@lcsc-ui/components/ProductList';
import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';
import { throttle, uniqWith, groupBy, map, uniq, flatMap } from 'lodash-es';
import styled from 'styled-components';

import FeedbackModal from './components/FeedbackModal';
import ImageSwiper from './components/ImageSwiper';
import { StyledTable } from './index.style';

const aliasMap = new Map();
let moreChannelList = [];
let showOsCoupon = false;

const StyledProductWrapper = styled.div`
  #lcxh ul {
    background: #f0f2f7;
    border-radius: 9px 9px 0px 0px;
  }
  .lcsc-product-item:hover {
    box-shadow: none;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }
  .swiper-pagination {
    display: none;
  }
`;

export default function SelectionDetail(props) {
  const { selectionProductDetailData, searchResultData } = props;
  const {
    mainProductCode,
    brandName,
    productModel,
    selectionModule,
    selectionFunction,
    selectionSegment,
    projectDesc,
    imgList,
    fileList,
    openProjectInfoList,
    showStockBtn,
    applicationTag,
  } = selectionProductDetailData;
  const { resourceData } = useContext(LayoutContext);
  const [isOpen, setIsOpen] = useState(false);
  const [searchResult] = useState(searchResultData);
  const productItemRefs = useRef([]);
  const [secondQueryIsEmpty] = useState(searchResultData?.productRecordList?.length === 0);
  const [moreChannelVO, setMoreChannelVO] = useState({});
  const [marketLabelVO, setMarketLabelVO] = useState({});
  const [moreOsCoupon, setMoreOsCoupon] = useState({});
  const [favoriteList, setFavoriteList] = useState([]);
  const [hasInit, setHasInit] = useState(false);

  useEffect(() => {
    init();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (hasInit) {
      moreChannelList =
        searchResult?.productRecordList?.map((item) => {
          return {
            uuid: item?.productVO?.productId,
            productCode: item?.productVO?.productCode,
            productModel: item?.productVO?.productModel,
            brandId: item?.productVO?.productGradePlateId,
            brandName: item?.productVO?.productGradePlateName,
          };
        }) || [];
      getMoreChannel();
      getFavoriteList();
      getMarketLable();
    }
  }, [searchResult?.productRecordList, hasInit]);

  const handleScroll = throttle(() => {
    if (productItemRefs?.current?.length > 0) {
      productItemRefs?.current.forEach((item) => {
        item?.checkButtonPosition();
      });
    }
  }, 200);

  const handleClose = () => {
    setIsOpen(false);
  };

  // 获取运营标签
  function getMarketLable() {
    const list = moreChannelList;
    if (list.length === 0) {
      return;
    }
    const params = list.map((item) => item.uuid);
    selectProductLabel(params).then((res) => {
      const list = res?.result;
      if (list?.length > 0) {
        const obj = {};
        list.forEach((item) => {
          obj[item?.productId] = item;
        });
        setMarketLabelVO((prev) => ({
          ...prev,
          ...obj,
        }));
      }
    });
  }

  // 获取收藏列表
  function getFavoriteList() {
    if (moreChannelList.length === 0) {
      return;
    }
    const productIds = moreChannelList.map((item) => item.uuid).join();
    selectProductFavorite({ productIds })
      .then((res) => {
        setFavoriteList(res?.result?.map((item) => item.toString()) || []);
      })
      .catch((error) => {
        console.error('获取收藏列表失败', error);
      });
  }

  function getMoreChannel() {
    let from = '';
    const { pathname } = location;
    if (Utils.getUrlParam('from') === 'kw') {
      from = Utils.getUrlParam('from');
    } else if (pathname.startsWith('/global.html')) {
      from = Utils.safeEncodeURI(searchResult?.globalSearchKeyword || '');
    } else if (pathname.startsWith('/brand')) {
      from = 'brand';
    } else if (pathname.startsWith('/catalog')) {
      from = 'catalog';
    }
    const paramJson = moreChannelList;
    if (paramJson.length === 0) {
      return;
    }
    searchMoreChannel({ from, paramJson, index: 0 }).then((res) => {
      if (res?.result && Object.keys(res?.result).length) {
        const list = [];
        const newObj = {};
        Object.keys(res?.result).forEach((key) => {
          if (/\d+/.test(key)) {
            if (res?.result[key]?.length > 0) {
              res.result[key].forEach((item) => {
                list.push({
                  provider: item?.provider,
                  brandId: item?.brandId,
                });
              });
            }
            newObj[key] = res?.result[key]?.map((item) => {
              return {
                ...providerItemFormat(item),
                track_zone: res?.result?.track_zone,
              };
            });
          }
        });
        setMoreChannelVO((perv) => ({
          ...perv,
          ...newObj,
        }));
        setOverseaCoupon(list, true);
      }
    });
  }

  // 格式化海外代购/立创订货巷
  function providerItemFormat(item) {
    const aliasItem = aliasMap.get(item?.provider) || {};
    return {
      ...item,
      providerAlias: aliasItem?.providerAlias || item?.provider,
      canDetailsPage: aliasItem?.providerAlias || false,
      useSourcePartId: aliasItem?.useSourcePartId || false,
    };
  }

  function init() {
    Utils.asyncAll([searchAlias(), isCounponUnavailableForOversea()]).then(([alias, ovease]) => {
      if (alias?.result?.length) {
        alias.result.forEach((item) => {
          aliasMap.set(item?.provider, item);
        });
      }
      showOsCoupon = !ovease?.result;
      setHasInit(true);
    });
  }

  function setOverseaCoupon(list, isMore) {
    if (!showOsCoupon) {
      return;
    }
    const arr = uniqWith(list, (a, b) => a?.provider === b?.provider && a?.brandId === b?.brandId);
    if (arr.length > 0) {
      activityOverseaCouponTips(arr).then((res) => {
        if (res?.result) {
          if (isMore) {
            setMoreOsCoupon((prev) => ({
              ...prev,
              ...res?.result,
            }));
          }
        }
      });
    }
  }

  // 图片轮播数据
  const images =
    imgList?.map((item, index) => ({
      key: index,
      url: resourceData?.projectConfigVO?.lcscImageUrl + (item.cropImgUrl ? item.cropImgUrl : item.originImgUrl),
      originUrl: resourceData?.projectConfigVO?.lcscImageUrl + item.originImgUrl,
      alt: item.fileName,
    })) || [];

  // 项目参考文件数据
  const referenceFiles =
    fileList?.map((item, index) => ({
      ...item,
      key: index,
      type: item.fileProperty,
      name: item.fileName,
      action: 'download',
    })) || [];

  const groupByFileProperty = (files) => {
    const grouped = groupBy(files, 'fileProperty');
    const order = uniq(map(files, 'fileProperty'));
    return flatMap(order, (prop) => grouped[prop]);
  };

  const sortedReferenceFiles = groupByFileProperty(referenceFiles);

  // 计算需要合并的行数
  const processedData = sortedReferenceFiles.map((item, index) => {
    // 查找相同分类的项目
    const sameCategoryItems = sortedReferenceFiles.filter((i) => i.type === item.type);
    // 如果是同分类的第一个项目，设置rowSpan为相同分类的项目数
    if (index === sortedReferenceFiles.findIndex((i) => i.type === item.type)) {
      return {
        ...item,
        rowSpan: sameCategoryItems.length,
      };
    }
    // 否则设置为0，不渲染
    return {
      ...item,
      rowSpan: 0,
    };
  });

  // 项目参考文件表格列定义
  const referenceColumns = [
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      width: 180,
      onCell: () => {
        return {
          style: {
            paddingLeft: 22,
          },
        };
      },
      render: (text, record) => {
        const obj = {
          children: text,
          props: {
            style: { verticalAlign: 'middle' },
          },
        };
        obj.props.rowSpan = record.rowSpan;
        return obj;
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      onHeaderCell: () => {
        return {
          style: {
            paddingLeft: 36,
          },
        };
      },
      onCell: () => {
        return {
          style: {
            paddingLeft: 36,
            borderRight: 0,
          },
        };
      },
      render: (text, record) => {
        let iconType = '';
        const fileUrl = record.fileShareUrl?.split('?')?.[0] || '';
        const fullFileUrl = fileUrl ? resourceData?.projectConfigVO?.lcscAttaUrl + fileUrl : null;
        const filePdfUrl = record?.filePdfUrl;
        if (fileUrl.endsWith('.pdf') || filePdfUrl) {
          iconType = 'pdf';
        } else if (fileUrl.endsWith('.zip')) {
          iconType = 'zip';
        } else if (fileUrl.endsWith('.rar')) {
          iconType = 'rar';
        }
        const previewUrl = fullFileUrl || filePdfUrl;
        return (
          <div className="flex items-center">
            {iconType && (
              <SvgIcon app="selection" iconName={iconType} className="mr-[10px] w-[20px] h-[25px] shrink-0" />
            )}
            {iconType === 'pdf' ? (
              <a href={previewUrl} target="_blank" onClick={() => handleBuriedPoint(record, previewUrl)}>
                {text}
              </a>
            ) : (
              <span>{text}</span>
            )}
          </div>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 180,
      render: (_, record) => {
        return record?.fileShareUrl ? (
          <button className="text-lcBlue" onClick={() => handleDownload(record)}>
            下载
          </button>
        ) : record?.filePdfUrl ? (
          <a href={record?.filePdfUrl} target="_blank">
            <button className="text-lcBlue">预览</button>
          </a>
        ) : (
          <></>
        );
      },
    },
  ];

  const handleBuriedPoint = (record, url) => {
    buriedPoint({
      ty: 'click',
      cp: 'selection_detail',
      op: 'preview_file',
      pf: 'pc',
      data: {
        fileName: record?.fileName,
        url: url,
      },
    });
  };

  const handleDownload = (record) => {
    buriedPoint({
      ty: 'click',
      cp: 'selection_detail',
      op: 'download_file',
      pf: 'pc',
      data: {
        fileName: record?.fileName,
      },
    });
    window.open(resourceData?.projectConfigVO?.lcscAttaUrl + record?.fileShareUrl, '_blank');
  };

  // 开源项目参考数据
  const openSourceProjects =
    openProjectInfoList?.map((item, index) => ({
      ...item,
      key: index,
      name: item.openProjectName,
      description: item.openProjectDesc,
    })) || [];

  // 开源项目表格列定义
  const openSourceColumns = [
    {
      title: '开源项目名称',
      dataIndex: 'name',
      key: 'name',
      width: 350,
      render: (text, record) => {
        return (
          <a className="text-lcBlue" href={record.openProjectUrl} target="_blank">
            {text}
          </a>
        );
      },
    },
    {
      title: '开源项目介绍',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const title = `${brandName || ''}+${productModel || ''}`;
  // 一级模块移除前缀
  const subTitle = `（${selectionModule?.replace(/^\d+\./, '')}-${selectionFunction}-${selectionSegment}方案）`;

  const ApplicationTagTemplate = () => {
    const tagList = applicationTag?.split('、') || [];
    return tagList.map((tag, index) => (
      <div className="text-[16px] break-words" key={index}>
        {tag}
      </div>
    ));
  };

  return (
    <div className="mt-[15px]">
      <section className={`p-[20px] bg-white rounded-[20px] ${images.length ? 'pb-[36px]' : ''}`}>
        <div className="mb-[20px] flex items-center">
          <h1 className="text-[24px] font-bold">{title}</h1>
          <span className="text-[20px] text-[#666666] font-bold">{subTitle}</span>
        </div>
        <div className="flex">
          {/* 左侧图片轮播 */}
          <ImageSwiper brandName={brandName} productModel={productModel} images={images} />
          <article className="ml-[30px] w-[558px] h-[355px] rounded-[10px] border border-solid border-[#F1F1F1]">
            <h2 className="p-[16px_20px] text-[18px] font-bold border-b border-solid border-[#F1F1F1]">芯片简介</h2>
            <div className="p-[16px_20px] max-h-[280px] overflow-auto scroll-custom">
              <p
                className="mb-[20px] text-[16px] break-words"
                dangerouslySetInnerHTML={{ __html: projectDesc || '暂无数据' }}
              />
              {applicationTag?.length ? (
                <>
                  <h3 className="text-[16px] font-bold">芯片特点：</h3>
                  <ApplicationTagTemplate />
                </>
              ) : (
                <></>
              )}
            </div>
          </article>
        </div>
      </section>
      {(processedData.length > 0 || openSourceProjects.length > 0) && (
        <section className="mt-[20px] p-[20px] bg-white rounded-[20px]">
          {processedData.length > 0 && (
            <>
              <h2 className="mb-[16px] text-[18px] font-bold">项目参考文件</h2>
              <StyledTable
                columns={referenceColumns}
                dataSource={processedData}
                pagination={false}
                locale={{ emptyText: '暂无数据' }}
                bordered
                scroll={{ y: 330 }}
              />
            </>
          )}
          {openSourceProjects.length > 0 && (
            <>
              <h2 className={`${processedData.length ? 'mt-[45px]' : ''} mb-[16px] text-[18px] font-bold`}>
                开源项目参考
              </h2>
              <StyledTable
                columns={openSourceColumns}
                dataSource={openSourceProjects}
                pagination={false}
                locale={{ emptyText: '暂无数据' }}
                bordered
              />
            </>
          )}
        </section>
      )}
      <section className="mt-[20px] bg-white rounded-[20px]">
        <h2 className="mb-[16px] p-[20px_20px_0] text-[18px] font-bold">方案关联商品</h2>
        <StyledProductWrapper>
          <ProductList track_zone={props?.track_zone} searchResult={searchResult} showStockBtn={showStockBtn}>
            {!secondQueryIsEmpty &&
              searchResult?.productRecordList?.map((item, index) => {
                const spm = `xh${index + 1}`;
                return (
                  <div className="relative mb-[10px] custom-group" key={item?.productVO?.productId}>
                    <ProductItem
                      ref={(el) => (productItemRefs.current[index] = el)}
                      offsetTop={196}
                      {...item}
                      moreChannelVO={moreChannelVO[item?.productVO?.productId]}
                      marketLabelVO={marketLabelVO[item?.productVO?.productId]}
                      osCoupon={moreOsCoupon}
                      isFavorite={favoriteList?.includes(item?.productVO?.productId)}
                      index={index}
                      rs_log={item?.rs_log}
                      spm={spm}
                      dataCustomData={JSON.stringify({
                        productType: 'main',
                        productId: item?.productVO?.productId,
                      })}
                    />
                  </div>
                );
              })}
            {secondQueryIsEmpty && <EmptyText />}
          </ProductList>
        </StyledProductWrapper>
      </section>
      <div className="mt-[15px] text-center">
        <button className="text-[#FF7800] text-[14px]" onClick={() => setIsOpen(true)}>
          欢迎填写选型反馈
        </button>
      </div>
      <FeedbackModal productCode={mainProductCode} open={isOpen} onClose={handleClose} />
    </div>
  );
}
